module.exports = __webpack_public_path__ + "img/app3.e467323c.png";